import {ReactComponent as Icon} from '@image/icon_shock.svg';

const IconShock = () => {
    return   <Icon />;
};

export default IconShock;